import React, { useEffect } from "react";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import { useForm } from "react-hook-form";
import useGetHook from "../../../../customHooks/useGetHook";
import APIS from "../../../../constant/Endpoint";
import usePatchHook from "../../../../customHooks/usePatchHook";
import TextField from "../../../Reusable/TextInput";
import ComboboxInput from "../../../Reusable/ComboboxInput";
import Button from "../../../Reusable/Button";
import { yupResolver } from "@hookform/resolvers/yup";
import { AddContactForm } from "../../../../utils/validationSchemas";
import PhoneNumberField from "../../../Reusable/PhoneNumberField";

const UpdateContacts = ({
  id,
  setIsOpen,
  invalidateQuery,
}: {
  id: string | number;
  setIsOpen: (val: boolean) => void;
  invalidateQuery: () => void;
}) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
    watch,
    getValues,
    setError,
    clearErrors,
    control,
  } = useForm({
    resolver: yupResolver(AddContactForm),
  });

  const { data } = useGetHook({
    queryKey: [`contact-${id}`],
    url: `${APIS.CONTACT}${id}/`,
    params: {},
  });

  useEffect(() => {
    if (data) {
      reset({
        full_name: data.full_name,
        email: data.email,
        phone_number: data.phone_number,
        dob: data.dob,
        group: data.group,
      });
    }
  }, [data, reset]);

  const { mutateAsync, isLoading } = usePatchHook({
    queryKey: [`contact-${id}`],
    navigateURL: "",
  });

  const handleUpdate = async (values: any) => {
    const url = `${APIS.CONTACT}${id}/`;
    const formData = { ...values };
    try {
      const res = await mutateAsync({ url, formData, setError });
      if (res?.status === 200) {
        setIsOpen(false);
        invalidateQuery();
      }
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div className={tw`w-full mt-5`}>
      <form
        className={tw`grid grid-cols-1 md:grid-cols-2 gap-4`}
        onSubmit={handleSubmit(handleUpdate)}
      >
        <div className={tw`col-span-2`}>
          <ComboboxInput
            url={APIS.CONTACT_GROUP}
            queryKey="contact-groups"
            register={register("group")}
            errors={errors.group}
            name="group"
            props={{ is_active: true }}
            label={"Group Name"}
            setValue={setValue}
            watch={watch}
            placeholder="Search Group Name..."
            getValues={getValues}
            clearErrors={clearErrors}
          />
        </div>
        <TextField
          label={"Full Name"}
          placeholder="Enter Your Full Name Here..."
          register={register("full_name")}
          errors={errors.full_name}
        />
        <TextField
          label="Email"
          type="email"
          placeholder="Enter Your Email Here..."
          register={register("email")}
          errors={errors.email}
        />

        <PhoneNumberField
          control={control}
          name="phone_number"
          label={"Phone"}
          errors={errors.phone_number}
          labelWidth={100}
        />
        <TextField
          label="Date Of Birth"
          type="date"
          placeholder="Enter Your Date Of Birth Here..."
          register={register("dob")}
          errors={errors.dob}
        />

        <div className={tw`col-span-2 flex justify-end`}>
          <div className={tw`w-40`}>
            <Button label="Update Contact" type="submit" loading={isLoading} />
          </div>
        </div>
      </form>
    </div>
  );
};

export default UpdateContacts;
